import { useDebouncedState } from "./useDebouncedState";
import { markupStepsState, stepState } from "../markupAtoms";
import { useRecoilValue } from "recoil";
import { Step } from "../../../types/markup";

export const useDebouncedAddStep = (): ((data: Step) => void) => {
  const [markupSteps, setMarkupSteps] = useDebouncedState(markupStepsState);
  const step = useRecoilValue(stepState);

  return (data: Step) => {
    setMarkupSteps([...markupSteps.slice(0, step), data]);
  };
};
